import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NvMatTooltipModule } from '../../../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ListDisplayModule } from './../list-display.module';
import { ListDisplayGraph } from './list-display-graph.component';

@NgModule({
  declarations: [ListDisplayGraph],
  imports: [CommonModule, ListDisplayModule, NvMatTooltipModule],
  exports: [ListDisplayGraph],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ListDisplayGraphModule {
  /** */
}
